module.exports = __webpack_public_path__ + "media/images/emblems/Jongny-coat_of_arms-4f6341138b92c7516116931aafb9d722.svg";